import { Global } from "../../config/global";

import axios from "axios";

// handleCreateNewPassword: Funicón para editar la contraseña del usuario.
export const handleCreateNewPassword = async ({ password, newPassword }) => {
    try {
        let url = Global.url + `user/updatePassword`;
        let userData = JSON.parse(localStorage.getItem("userData"));
        console.log("esto es lo que voy a editar", userData.Usuario, password, newPassword);

        let data = JSON.stringify({
            "username": userData.Usuario,
            "password": password,
            "newPassword": newPassword,
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        const response = await axios.request(config);
        console.log("esta es la respuesta al cambiar la contraseña", response);
        return response;

    } catch (error) {
        console.log("error al restablecer la contraseña", error);
        return error
        throw error;
    }
};